import { api } from './api';

export interface ProductBrandDto {
  id: number;
  name: string;
  code?: string;
  logoUrl?: string;
  isFavourite: boolean;
  isActive: boolean;
  createdAt: string;
}

export async function fetchProductBrands(): Promise<ProductBrandDto[]> {
  const { data } = await api.get<ProductBrandDto[]>('/productbrands');
  return Array.isArray(data) ? data : [];
}

export async function createProductBrand(payload: { name: string; code?: string; logoUrl?: string; isFavourite?: boolean }): Promise<ProductBrandDto> {
  const { data } = await api.post<ProductBrandDto>('/productbrands', payload);
  return data;
}

export async function updateProductBrand(id: number, payload: { name: string; code?: string; logoUrl?: string; isFavourite?: boolean }): Promise<ProductBrandDto> {
  const { data } = await api.put<ProductBrandDto>(`/productbrands/${id}`, payload);
  return data;
}

export async function deleteProductBrand(id: number): Promise<void> {
  await api.delete(`/productbrands/${id}`);
}
